<template>
  <div>
    <main-layout :showSideBar="!issidebar">
      <div
        class="content-wrap bill-download"
        v-loading="loadingtable"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
      >
        <div class="download-box">
          <el-radio-group v-model="tradeType" @change="tradeTypeChange" size="small">
            <el-radio-button label="daterange">日账单</el-radio-button>
            <el-radio-button label="month">月账单</el-radio-button>
          </el-radio-group>
        </div>
        <div>
          <el-form ref="searchForm" size="small" label-width="110px" :inline="true">
            <el-form-item label="请选择交易日期">
              <datePicker
                v-if="!isChoiceMonth"
                :defaultValue="createDateDefaultValue"
                :reset="resetTog"
                disablededTime="2020-05-31"
                :maxInterval="maxInterval"
                v-model="date"
              />
              <el-date-picker
                v-else
                size="small"
                :clearable="false"
                v-model="monthDate"
                format="yyyy-MM"
                value-format="yyyy-MM"
                :picker-options="disabledDate"
                type="month"
                placeholder="选择月"
              />
            </el-form-item>
            <el-form-item label="部门/门店">
              <treeselect
                class="tree-select form-select"
                :default-expand-level="1"
                noOptionsText="暂无选项"
                noResultsText="暂无选项"
                v-model="departmentId"
                placeholder="请输入"
                :normalizer="normalizer"
                :options="treedata"
              >
                <label
                  slot="option-label"
                  slot-scope="{ node, labelClassName }"
                  :class="labelClassName"
                  :title="node.label"
                >
                  {{ node.label }}
                </label>
              </treeselect>
            </el-form-item>
            <el-form-item>
              <el-button @click="searchForm" type="primary">搜索</el-button>
              <el-button @click="reset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <bill-table :table-data="tableData" :userAuth="userAuth" @download="download"></bill-table>
        <Paging
          layout="prev, pager, next, total, sizes, jumper"
          v-if="!isChoiceMonth && aCount > 10"
          :currentPage="pagObj"
          :total="aCount"
          :handleCurrentChange="handleCurrentChange"
          :handleSizeChange="handleSizeChange"
        ></Paging>
        <iframe
          v-if="actionUrl"
          @load="iframeLoad"
          ref="iframeExportRef"
          frameborder="0"
          name="export-target"
          style="display: none"
        ></iframe>
        <form
          style="display: none"
          method="get"
          :action="actionUrl"
          ref="exportForm"
          target="export-target"
        >
          <input
            type="hidden"
            :name="isChoiceMonth ? 'tradeMonth' : 'tradeDate'"
            :value="tradeDate"
          />
          <input type="hidden" name="departmentId" :value="departmentId" />
        </form>
      </div>
    </main-layout>
  </div>
</template>

<script>
import dayjs from 'dayjs';
// import { moment } from "@utils/moment";
import MainLayout from '@/views/layout/mainlayout';
import BillTable from './table';
import { _dateFormat, getNearestWeekDates } from '@/utils/times';
import Paging from '@components/public/paging';
import datePicker from '@components/public/datePicker';
import axiosRequestNew from '@api/axiosRequestNew';
import { messageTips } from '@api/utils';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'BillDownload',
  components: {
    MainLayout,
    BillTable,
    datePicker,
    Paging,
    Treeselect,
  },
  data() {
    return {
      tableData: [],
      aCount: 0,
      oldtimer: '',
      resetTog: false,
      date: '',
      monthDate: this.getLastMonth(),
      issidebar: false,
      loadingtable: false,
      departmentId: null,
      tradeType: 'daterange',
      treedata: [],
      pagObj: {
        currentPage: 1,
        pageSize: 10,
      },
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children,
        };
      },
      disabledDate: {
        disabledDate(time) {
          const currentTime = dayjs(new Date()).valueOf();
          // 上个月1号
          // const startDate = dayjs()
          //   .subtract(1, "month")
          //   .startOf("month")
          //   .valueOf();
          // 当月4号
          const endDate = dayjs().startOf('month').add(3, 'day').valueOf();
          if (currentTime < endDate) {
            return (
              time.getTime() < new Date('2020-06').getTime() ||
              time.getTime() >
                new Date(new Date().getFullYear(), new Date().getMonth(), 1).getTime() ||
              time.getTime() >=
                dayjs()
                  .month(dayjs().month() - 1)
                  .startOf('month')
                  .valueOf()
            );
          } else {
            return (
              time.getTime() < new Date('2020-06').getTime() ||
              time.getTime() >=
                new Date(new Date().getFullYear(), new Date().getMonth(), 1).getTime()
            );
          }
        },
      },
      userAuth: {
        exportBill: true,
      },
      actionUrl: '',
      tradeDate: '',
      allCompanyAuthority: true,
      registerType: '',
    };
  },
  created() {
    this.getAuth();
    // 获取部门信息
    this.api.post('load/getDeptTree.do', {}).then((res) => {
      if (res.code == '200') {
        this.treedata = res.data;
      } else {
        this.$message.error(res.message);
      }
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.searchForm();
    });
  },
  computed: {
    isChoiceMonth() {
      return this.tradeType === 'month';
    },
    createDateDefaultValue() {
      if (this.allCompanyAuthority) {
        return getNearestWeekDates(29);
      } else {
        return getNearestWeekDates(6);
      }
    },
    maxInterval() {
      if (this.allCompanyAuthority) {
        return 120;
      } else {
        return 7;
      }
    },
  },
  methods: {
    iframeLoad() {
      const _this = this;
      this.$nextTick(() => {
        if (_this.$refs.iframeExportRef.contentWindow.document.body.innerText) {
          try {
            const obj = JSON.parse(
              _this.$refs.iframeExportRef.contentWindow.document.body.innerText,
            );
            console.log(obj);
            _this.$message.warning(obj.message);
          } catch (e) {
            console.log(e);
            _this.$message.warning('导出失败，请联系管理员！');
          }
        }
      });
    },
    getLastMonth() {
      const currentTime = dayjs(new Date()).valueOf();
      const endDate = dayjs().startOf('month').add(3, 'day').valueOf();
      if (currentTime < endDate) {
        return dayjs()
          .month(dayjs().month() - 2)
          .startOf('month')
          .format('YYYY-MM');
      }
      //获取上个月年月
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth();
      if (month < 10) {
        month = '0' + month;
      }
      if (month == 0) {
        year = year - 1;
        month = 12;
      }
      return year + '-' + month;
    },
    getAuth() {
      const registerType = sessionStorage.getItem('registerType');
      this.registerType = registerType;
      const myShowMenus = JSON.parse(sessionStorage.getItem('myShowMenusTips'));
      const { allCompanyAuthority } = JSON.parse(sessionStorage.getItem('loginData'));
      // -1=自然人 0=个人 1=企业（2，3，4也可能是企业）
      if (registerType) {
        const payState = sessionStorage.getItem('payState');
        if (payState && payState == '0') {
          this.issidebar = true;
        }
      }
      if (registerType == 0) {
        this.userAuth = myShowMenus;
        this.allCompanyAuthority = allCompanyAuthority;
      }
    },
    tradeTypeChange(val) {
      this.pagObj = {
        currentPage: 1,
        pageSize: 10,
      };
      this.aCount = 0;
      this.tableData = [];
      this.$nextTick(() => {
        this.searchForm();
      });
    },
    validateSearchForm() {
      const starttime = this.date[0];
      const endtime = this.date[1];
      if (!this.isChoiceMonth && starttime && endtime) {
        if (this.getDays(starttime, endtime) > 119) {
          this.$message.error('时间跨度不得超过120天！');
          return false;
        }
      }
      if (this.isChoiceMonth && !this.monthDate) {
        this.$message.error('请选择交易日期');
        return false;
      }
      // 2021-11-18 选择部门查询 交易日期限制查询7天数据
      if (this.tradeType === 'daterange' && this.departmentId && Number(this.departmentId) !== -1) {
        if (!this.monthDate) {
          this.$message.error('请选择交易日期');
          return false;
        }
        const rangeDay = dayjs(endtime).diff(dayjs(starttime), 'days');
        if (rangeDay > 7) {
          this.$message.error('交易日期间隔不可大于7天');
          return false;
        }
      }
      return true;
    },
    download(tradeDate) {
      this.tradeDate = tradeDate;
      if (this.isChoiceMonth) {
        this.actionUrl = `//${window.location.host}/juheCustomer/customerBill/exportMonthBill.do`;
        // this.actionUrl = `//${window.location.host}/juheCustomer/customerBill/exportMonthBill.do?tradeMonth=${tradeDate}`;
      } else {
        this.actionUrl = `//${window.location.host}/juheCustomer/customerBill/exportDayBill.do`;
        // this.actionUrl = `//${window.location.host}/juheCustomer/customerBill/exportDayBill.do?tradeDate=${tradeDate}`;
      }
      this.$nextTick(() => {
        this.$refs.exportForm.submit();
      });
    },
    getDays(strDateStart, strDateEnd) {
      const strSeparator = '-'; // 日期分隔符
      let oDate1;
      let oDate2;
      let iDays;
      oDate1 = strDateStart.split(strSeparator);
      oDate2 = strDateEnd.split(strSeparator);
      const strDateS = new Date(oDate1[0], oDate1[1] - 1, oDate1[2]);
      const strDateE = new Date(oDate2[0], oDate2[1] - 1, oDate2[2]);
      iDays = parseInt(Math.abs(strDateS - strDateE) / 1000 / 60 / 60 / 24); // 把相差的毫秒数转换为天数
      return iDays;
    },
    getPrevMonth() {
      let nowdate = new Date();
      nowdate.setMonth(nowdate.getMonth() - 1);
      const y = nowdate.getFullYear();
      const m = nowdate.getMonth() + 1;
      const formatwdate = `${y}-${m > 9 ? m : `0${m}`}`;
      return formatwdate;
    },
    getSearchFormObj() {
      const searchFormObj = {};
      if (!this.isChoiceMonth) {
        if (Array.isArray(this.date) && this.date.length > 0) {
          searchFormObj.tradeDateStart = this.date[0];
          searchFormObj.tradeDateEnd = this.date[1];
        }
      }
      const formKeys = Object.keys(searchFormObj);
      formKeys.forEach((key) => {
        if (searchFormObj[key] === '' || searchFormObj === undefined) {
          delete searchFormObj[key];
        }
      });
      return searchFormObj;
    },
    searchDate() {
      const dateDiff = (new Date(this.date[1]) - new Date(this.date[0])) / (24 * 3600 * 1000);
      if (dateDiff >= this.maxInterval) {
        messageTips(this, 'error', `时间跨度不能超过${this.maxInterval}天！`);
        return false;
      }
      this.loadingtable = true;
      const searchFormData = this.getSearchFormObj();
      axiosRequestNew
        .get('customerBill/pageDayOrderStatistics.do', {
          params: {
            ...searchFormData,
            departmentId: this.departmentId,
            pageSize: this.pagObj.pageSize,
            current: this.pagObj.currentPage,
          },
        })
        .then((res) => {
          if (res.code == '200') {
            const { data } = res;
            this.tableData = (data && data.pageList) || [];
            this.aCount = (data && data.aCount) || 0;
          }
        })
        .finally(() => {
          this.loadingtable = false;
        });
    },
    searchMonth() {
      this.loadingtable = true;
      axiosRequestNew
        .get('customerBill/selectTradeByMonth.do', {
          params: {
            tradeDate: this.monthDate,
            departmentId: this.departmentId,
          },
        })
        .then((res) => {
          if (res.code == '200') {
            const { data } = res;
            this.tableData = (data && [data]) || [];
          }
        })
        .finally(() => {
          this.loadingtable = false;
        });
    },
    searchForm() {
      if (!this.validateSearchForm()) {
        return;
      }
      if (this.isChoiceMonth) {
        this.searchMonth();
      } else {
        this.searchDate();
      }
    },
    handleSizeChange(val) {
      this.pagObj.pageSize = val;
      this.pagObj.currentPage = 1;
      this.searchForm();
    },
    handleCurrentChange(val) {
      this.pagObj.currentPage = val;
      this.searchForm();
    },
    reset() {
      this.resetTog = !this.resetTog;
      if (this.registerType === '0' && !this.allCompanyAuthority) {
        this.date = [
          _dateFormat(new Date(new Date().getTime() - 6 * 24 * 60 * 60 * 1000), 'yy-MM-dd'),
          _dateFormat(new Date(), 'yy-MM-dd'),
        ];
      } else {
        this.date = [
          _dateFormat(new Date(new Date().getTime() - 29 * 24 * 60 * 60 * 1000), 'yy-MM-dd'),
          _dateFormat(new Date(), 'yy-MM-dd'),
        ];
      }
      this.departmentId = null;
      this.monthDate = this.getLastMonth();
      this.searchForm();
    },
  },
};
</script>

<style lang="scss" scoped>
.bill-download {
  .download-box {
    margin-bottom: 20px;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 220px;
  }
}
</style>
